import { StyledButton } from 'components/Button/Button';
import NavLink, {
  Container as NavLinkContainer
} from 'components/NavLink/NavLink';
import withColorQuery, {
  INavBarText,
  WithColorQueryProps
} from 'enhancers/withColorQuery';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withLanguageState, {
  WithLanguageProps
} from 'enhancers/withLanguageState';
import * as React from 'react';
import Dropdown, {
  DropdownContent,
  DropdownTrigger
} from 'react-simple-dropdown';
import styled from 'styled-components';

interface IProps {
  color?: string;
}

type Props = IProps &
  IWithCountryProps &
  WithColorQueryProps &
  WithLanguageProps;

export class NavBar extends React.Component<Props> {
  public dropdown: Dropdown | null;
  public render() {
    const showDropDown = () => {
      if (this.dropdown) {
        this.dropdown.show();
      }
    };

    const hideDropDown = () => {
      if (this.dropdown) {
        this.dropdown.hide();
      }
    };

    let text: INavBarText | { [key: string]: string } = {};

    if (
      !this.props.loading &&
      this.props.data &&
      this.props.data.fetch.Country.Navbar
    ) {
      text = { ...this.props.data.fetch.Country.Navbar };
      Object.keys(text).forEach(key => {
        text[key] = this.props.getText(text[key]);
      });
    }

    return (
      <Container>
        <NavLink to={``} exact={true}>
          {text.Home || 'Home'}
        </NavLink>
        <Dropdown ref={ref => (this.dropdown = ref)}>
          <DropdownTrigger>
            <AboutText onMouseEnter={showDropDown}>
              {text.AboutHeading || 'About'}
            </AboutText>
          </DropdownTrigger>
          <Content>
            <AboutContent onMouseLeave={hideDropDown}>
              <NavLink to={`/about`}>{text.About || 'About'}</NavLink>
              <NavLink to={`/history`}>{text.History || 'History'}</NavLink>
              <NavLink to={`/gallery`}>{text.Gallery || 'Gallery'}</NavLink>
              <NavLink to={`/partners`}>{text.Partners || 'Partners'}</NavLink>
              <NavLink to={`/faq`}>{text.FAQ || 'FAQ'}</NavLink>
            </AboutContent>
          </Content>
        </Dropdown>
        <NavLink to={`/rules`}>{text.Rules || 'Rules'}</NavLink>
        <NavLink to={`/events`}>{text.Events || 'Events'}</NavLink>
        {/* <NavLink to={`/scores`}>
          {text.Scores || 'Scores'}
        </NavLink> */}
        <NavLink to={`/world-finals`}>
          {text.WorldFinals || 'World Finals'}
        </NavLink>
        <NavLink to={`/contact`}>{text.Contact || 'Contact'}</NavLink>
        {/* <Link to={text.RegisterLink || `/register`}>
          <Button>{text.Register || 'Register'}</Button>
        </Link> */}
      </Container>
    );
  }
}

const AboutText = styled.p`
  font-size: 14px;
  margin: 0 50px;
  cursor: pointer;
  font-weight: 300;
  @media (max-width: 1300px) {
    margin: 0;
  }
`;

const Container = styled.div`
  display: flex;
  text-transform: uppercase;
  align-items: center;
  padding-left: 30px;
  @media (max-width: 1300px) {
    justify-content: space-around;
  }
  @media (max-width: 1000px) {
    ${NavLinkContainer}, ${StyledButton}, ${AboutText} {
      font-size: 14px;
    }
  }
  @media (max-width: 749px) {
    padding-left: 0;
    flex-direction: column;
    ${NavLinkContainer} {
      a {
        padding: 10px;
      }
    }
    ${AboutText} {
      padding: 10px;
    }
  }
`;

const AboutContent = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  padding: 10px;
  color: #333;
  transform: translate(23%, 20px);
  & > * {
    padding: 10px 0;
    margin: 0 15px;
  }
  @media (max-width: 749px) {
    background: white;
  }
`;

const Content = styled(DropdownContent)`
  z-index: 3;
`;

export default withLanguageState(withCountry(withColorQuery(NavBar)));



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.tsx